<script>
import { mapActions, mapMutations } from 'vuex';
import jwt_decode from 'jwt-decode';
  export default {
    data() {
      return {
        /**
         * Allowed Routes:
         * Shop, Clinic, Settings, Staff, Compliance, Invoice, Drug, POS, Insights, CustomConsentForm, CustomAftercareDocument, CustomProduct
         */
        allowedRoutes:['Shop', 'Drug', 'Settings', 'Clinic', 'Staff', 'Compliance', 'Invoice', 'POS', 'Insights', 'CustomConsentForm', 'CustomAftercareDocument', 'CustomProduct'],
        showlanding: false,
      };
    },
    async created() {
      this.userRole = this.$store.state.AppActiveUser.userRole.toLowerCase();
      this.organizationId = localStorage.getItem(
      `${process.env.VUE_APP_ACCESS_TOKEN_NAME}OrganizationId`
      );
      this.token = this.$route.query.token;
      this.embedClinicId = this.$route.query.clinicId;
      this.SET_BEARER(this.$route.query.token);
      if(this.token && this.token.length>0){
        this.userId = jwt_decode(this.token).id;
      }
      else{
        this.userId = JSON.parse(
          localStorage.getItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}User`)
        )._id;
      }
      if(this.embedClinicId && this.embedClinicId.length>0){
        this.organizationId = await this.fetchOrgIdByClinic();

        localStorage.setItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}EmbededData`, JSON.stringify({
          token: this.token,
          organizationId:this.organizationId,
          clinicId: this.embedClinicId,
        }));
      }
    },
    mounted() {
      this.redirectBackIfNotPermitted();
    },
    methods: {
      ...mapActions('drugbook', ['getAssociatedClinics']),
      ...mapActions('clinic', ['fetchClinicsDetail']),
      ...mapMutations('admin',['SET_BEARER']),
      async getUserPermissions() {
        try {
          const user = this.$store.state.AppActiveUser;
        
          let {data, status} = await this.$store.dispatch('admin/fetchUserPermission', {
            userId: user.id,
            organizationId: this.organizationId,
          });

          if (status != 200) return [];

          let isDrugbookEnabled = false;
          let isInventoryEnabled = false;
          let isAnalyticsEnabled = false;
          let hasDrugEntry = null;

          if(this.organizationId) {
              const organizationStatus = await this.getOrganizationComplianceStatus();
              isAnalyticsEnabled = organizationStatus.isAnalyticsEnabled;
              isDrugbookEnabled = organizationStatus.isDrugbookEnabled;
              isInventoryEnabled = organizationStatus.isInventoryEnabled;
              hasDrugEntry = await this.checkClinicDrugEntry();
          }

          if (!isAnalyticsEnabled) {
            this.allowedRoutes = [
              'Shop', 'Drug', 'Settings', 'Clinic', 'Staff', 'Compliance',
              'Invoice', 'POS', 'CustomConsentForm', 'CustomProduct',
            ];
          }

          let permissionsList = data.map((item) => item.permission.name).filter(permission => this.allowedRoutes.includes(permission));
          this.$store.commit('admin/SET_USER_PERMISSION', permissionsList);

          const permissionMenus = this.permissionMenuItems.filter((menu) => {
            // if no permission key, default menu
            if (!menu.permission) {
              if (menu.slug === 'referral' && this.isDoctorEMR()) {
                return;
              }
              return menu;
            }

            if (menu.header === 'Settings') {
              const isCustomProductPermiExist = permissionsList.find((permi) => permi === 'CustomProduct');
              const isCustomConsentPermiExist = permissionsList.find((permi) => permi === 'CustomConsentForm');
              const isCustomAftercarePermiExist = this.isDoctorEMR();
              const isClinicPermiExist = permissionsList.find((permi) => permi === 'Clinic');
              const isStaffPermiExist = permissionsList.find((permi) => permi === 'Staff');

              // Remove consent form menu if permission is off
              const consentFormIndex = menu.items.findIndex((child) => child.name === 'Consent Forms');
              if (!isCustomConsentPermiExist && consentFormIndex !== -1) {
                menu.items.splice(consentFormIndex, 1);
              }

               /**
               * 1. If the user is NOT a Doc EMR and has a custom product list - revoke access to the product list.
               * 2. If the user is a Doc EMR and has a custom product list - allow access.
               * 3. If the user is a Doc EMR and does NOT have a custom product list - always allow access.
               * 4. If the user is NOT a Doc EMR and does NOT have a custom product list - display the product list.
               */ 
              
              // Define menu item names dynamically based on user type
              const customProductListName = `${user.userType} Custom Products List`;
              const productListName = `${user.userType} Products List`;

               const removeMenuItem = (menu, itemName) => {
                 // Find the index of the item with the specified name
                const index = menu.items.findIndex((child) => child.name === itemName);
                // If the item exists, remove it from the array
                if (index !== -1) {
                  menu.items.splice(index, 1);
                }
              };
              // Remove the appropriate menu item based on the user's Doc EMR status
              removeMenuItem(menu, this.isDoctorEMR() ? productListName : customProductListName);

              /**
               * Show other menu even setting permission is off
               * - Clinic List
               * - Staff List
               * - Consent Form
               * - Aftercare Documents [AU only]
               * - Custom Product List
               */
              if (
                !permissionsList.includes(menu.permission) &&
                this.allowedRoutes.includes(menu.permission) &&
                (
                  isStaffPermiExist || isClinicPermiExist ||
                  isCustomConsentPermiExist || isCustomAftercarePermiExist ||
                  isCustomProductPermiExist || this.isDoctorEMR()
                )
              ) {
                const excludedMenu = [`${user.userType}-treatment-areas`, `${user.userType}-products-list`];
                menu.items = menu.items.filter((child) => !excludedMenu.includes(child.slug));

                return menu.items.length;
              }
            }

            if (menu.header === 'Compliance') {
              const hasDrugPermission = permissionsList.includes('Drug');
              const hasCompliancePermission = permissionsList.includes('Compliance');

              /**
               * Hide Inventory & Drugbook if:
               * - Drug permission is off, OR
               * - Clinic has no drug entry, OR
               * - Drugbook is disabled, OR
               * - User is an EMR doctor
               */
              const shouldHideDrugFeatures = (!hasDrugPermission && !hasDrugEntry) || !isDrugbookEnabled;

              if (shouldHideDrugFeatures) {
                menu.items = menu.items.filter(
                  (item) => !['Inventory', 'Drugbook'].includes(item.name)
                );
              }

              // Hide Inventory if not enabled
              if (!isInventoryEnabled) {
                menu.items = menu.items.filter((item) => item.name !== 'Inventory');
              }

              // Hide Compliance if permission is off
              if (!hasCompliancePermission) {
                menu.items = menu.items.filter((item) => item.name !== 'Compliance');
              }

              if (menu.items.length === 0) {
                return;
              }

              return hasCompliancePermission || hasDrugPermission || hasDrugEntry;
            }


            return this.$store.state['admin'].permissions.includes(menu.permission) &&
                    this.allowedRoutes.includes(menu.permission);
          });
          return permissionMenus || [];
        } catch(e) {
          /**
           * For users(doctor, nurse, basic & org-owner) not assigned to any orgs
           *
           **/
          const permissionMenus = this.permissionMenuItems.filter((menu) => {
            if (!menu.permission) return menu;

            if (menu.header === 'Settings' && menu.items.length > 0) {
              menu.items = menu.items.filter((childMenu) => !['Staff', 'Clinics'].includes(childMenu.name));
              return menu;
            }
          });

          return permissionMenus || [];
        }
      },
      async redirectBackIfNotPermitted() {
        let allowedPages = [];
        const userPermission = await this.getUserPermissions();
        userPermission.map(el => {
          if (el.items) {
            const subMenu = el.items.map(el => el.permission);
            allowedPages = [...allowedPages, ...subMenu];
          } else {
            allowedPages.push(el.permission);
          }
        });
        let currentPagePermission = this.$route.meta.permission;
        const docEMRrestrictedPageNames = ['referral']; // Pages restricted for doctor EMR
        if (this.isDoctorEMR() && docEMRrestrictedPageNames.includes(this.$route.name)) {
          this.$router.push(
            process.env.VUE_APP_REGION !== 'US'
              ? '/doctor/notice-board'
              : '/doctor/treatment-history'
          );
        }
        if (currentPagePermission) {
          if (!allowedPages.includes(currentPagePermission)) {
            if (this.userRole == 'nurse') {
              this.$router.push(
                  process.env.VUE_APP_REGION !== 'US'
                    ? '/nurse/notice-board'
                    : '/nurse/patients'
                );
            } else if (this.userRole == 'basic') {
              this.$router.push(
                  process.env.VUE_APP_REGION !== 'US'
                    ? '/basic/notice-board'
                    : '/basic/patients'
                );
            } else {
              this.$router.push(
                  process.env.VUE_APP_REGION !== 'US'
                    ? '/doctor/notice-board'
                    : '/doctor/treatment-history'
                );
            }

          }
        }
      },
      async checkClinicDrugEntry() {
        const { data } = await this.$store.dispatch(
          'drugbook/checkClinicDrugEntries',
          this.organizationId
        );

        return data.data;
      },
      async getOrganizationComplianceStatus() {
        const { data } = await this.$store.dispatch(
          'organization/fetchOrganizationDetails',
          this.organizationId
        );
        return data.data;
      },
      redirectToEntries() {
        if ( localStorage.getItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}EmbededData`)){
          this.$router.push({ path: '/drugbook/entries', query:{
            token: this.token,
            clinicId: this.embedClinicId,
          } });
        }else{
          this.$router.push({ name: this.getRoleRouteName('DrugbookEntries') });
        }
      },
      async fetchOrgIdByClinic(){
        const res = await this.fetchClinicsDetail(this.embedClinicId);
            const clinicsDetail = res.data.data;
            const orgId = clinicsDetail.organizationDetail._id;
            return orgId;
      },
      async fetchclinics() {
        return new Promise(async (resolve, reject) => {
          try {
            this.$vs.loading();
            const res = await this.getAssociatedClinics({
              userId: this.userId,
              orgId: this.organizationId,
            });
            const clinicsList = res.data.data.map((item) => {
              return {
                clinicId: item._id,
                name: item.clinicName,
                clinicsCount: item.clinicsCount,
                drugEntries: item.drugEntries,
              };
            });
            this.$vs.loading.close();
            if (
              clinicsList
                .map((clinic) => clinic.drugEntries)
                .reduce((total, number) => total + number, 0) > 0
            ) {
              this.redirectToEntries();
            }
            else{
              this.showlanding=true;
            }
            resolve();
          } catch (err) {
            reject(err);
          }
        });
      },
      isDoctorEMR() {
        if (this.$store.state.AppActiveUser.userRole.toLowerCase() !== 'doctor') return false;
        return !!this.$store.state.AppActiveUser.doctorEMRClinics.length;
      },
    },
  };
</script>
